var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.theme.isDark}},[(!_vm.currentUserLoaded)?_c('v-layout',{attrs:{"row":"","justify-center":"","align-center":""}},[_c('spinner')],1):_vm._e(),(_vm.isUserLoggedIn)?[_c('div',{staticClass:"app-layout"},[(!_vm.inIframe && !_vm.hideSidebar)?_c('app-sidebar'):_vm._e(),_c('router-view')],1),_c('app-modals')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }